import { BaseNumberIdDataDto } from '../../../classes/common';
export class VehicleAccidentImageDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.url = initializer.url;
        this.accidentId = initializer.accidentId;
    }
}
